/**
 * Layout — wrapper strony.
 *
 * Zmiany a11y:
 *  1. AccessibilityProvider (Context API) — zarządzanie kontrastem,
 *     rozmiarem czcionki i odstępami dla całego drzewa komponentów.
 *  2. Skip link (.skip-link) — pierwszy focusowalny element dokumentu,
 *     umożliwia pominięcie nawigacji (WCAG 2.4.1, poziom A).
 *  3. <main id="main-content" tabIndex="-1"> — cel skip linka
 *     i programatycznego focusu po nawigacji SPA.
 */
import React from "react"
import PropTypes from "prop-types"
import "../../styles/style.scss"
import Header from "./header"
import Footer from "./footer"
import Cookies from "../m-cookies"
import { AccessibilityProvider } from "../../context/AccessibilityContext"
import AccessibilityToolbar from "../a11y/AccessibilityToolbar"

const Layout = ({ children, marginTop }) => (
  <AccessibilityProvider>
    {/* Skip link — widoczny tylko przy focusie klawiatury */}
    <a className="skip-link" href="#main-content">
      Przejdź do treści głównej
    </a>

    <div className="wrapper">
      <Header />
      <AccessibilityToolbar />

      <main
        id="main-content"
        style={{ marginTop }}
        tabIndex="-1"
      >
        {children}
      </main>

      <script type="application/ld+json">{`{"@context":"http://schema.org","@type":"WebSite","@id":"#website","url":"https://medicusdukla.pl/","name":"Przychodnia specjalistyczna Medicus-Dukla. Prywatnie i NFZ","alternateName":"Poradnie: Podstawowa opieka zdrowotna / Poradnie specjalistyczne (NFZ) / Poradnie specjalistyczne prywatne. Diagnostyka. Usługi: Opieka Pielęgniarska Długoterminowa | Hospicjum domowe | Medycyna Pracy | Badania Kierowców i wszystkie kategorie | Transport sanitarny"}`}</script>

      <Footer />
      <Cookies />
    </div>
  </AccessibilityProvider>
)

Layout.propTypes = {
  children:  PropTypes.node.isRequired,
  marginTop: PropTypes.string,
}

export default Layout
